import ViewFuneralNotice from '../ViewFuneralNotice.vue'

export default [
    {
        path: '/funeral-notice/:token',
        name: '/funeral-notice/:token',
        component: ViewFuneralNotice,
        meta: {
            layout: 'public-layout'
        }
    },
]